// extracted by mini-css-extract-plugin
export var modal = "_54-0";